import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SubNavigationItems, { SubNavigationItemProps } from "go-app/components/Navigation/SubNavigationItems";
import { hasPermission, selectOrganization } from "go-security/services/organizations/selectors";
import { selectIsAdmin } from "go-security/services/users/selectors";

const SettingsNavigation = () => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const prefix = `/${organization.id}/settings`;
	const isAdmin = useSelector(selectIsAdmin);

	const hasSettingsPermission = useSelector(hasPermission("SETTINGS"));
	const hasSegmentPermission = useSelector(hasPermission("SEGMENT"));
	const hasManagePermission = useSelector(hasPermission("MANAGE"));

	const items: SubNavigationItemProps[] = [
		{
			title: t("modules.settings.field.company.title"),
			route: `${prefix}/company`,
			hide: !hasSettingsPermission,
		},
		{
			title: t("modules.settings.field.users.title"),
			route: `${prefix}/users`,
			hide: !isAdmin && !hasManagePermission,
		},
		{
			title: t("modules.settings.field.permissions.title"),
			route: `${prefix}/permissions`,
			hide: !isAdmin && !hasManagePermission,
		},
		{
			title: t("modules.settings.field.stocks.title"),
			route: `${prefix}/stocks`,
			hide: !hasSettingsPermission,
		},
		{
			title: t("modules.settings.field.stock.title"),
			route: `${prefix}/stock`,
			hide: !hasSettingsPermission,
		},
		{
			title: t("modules.settings.field.invoice.title"),
			route: `${prefix}/invoice`,
			hide: !hasSettingsPermission,
		},
		{
			title: t("lib:go_segment.list.header.title"),
			route: `${prefix}/segments`,
			hide: !isAdmin && !hasSettingsPermission && !hasSegmentPermission,
		},
		{
			title: t("modules.settings.field.export.title"),
			route: `${prefix}/export`,
			hide: !hasSettingsPermission,
		},
		{
			title: t("modules.settings.field.custom_field.title"),
			route: `${prefix}/custom_fields`,
			hide: !isAdmin && !hasSettingsPermission,
		},
		{
			title: t("modules.archives.header.title"),
			route: `${prefix}/archives`,
			hide: !hasSettingsPermission,
		},
		{
			title: t("lib:go_component.remove_organization.header.title"),
			route: `${prefix}/remove_organization`,
			hide: !hasManagePermission,
		},
	];

	return <SubNavigationItems title={t("modules.settings.header.title")} items={items} />;
};

export default SettingsNavigation;
